export default __webpack_public_path__ + "static/media/hero-login.e2285784.svg";